const programFormats = {
  'Traviss Technical College': 'On campus',
  'Lively Technical College': 'On campus',
  'Palm Beach State College': 'Online',
  'Indian River State College': 'On campus',
  'Seminole State College of Florida': 'Online and hybrid',
  'Daytona State College': 'On campus',
  'Tallahassee Community College': 'On campus',
  'Pensacola State College': 'On campus',
  'Florida State College at Jacksonville': 'On campus',
  'South Florida State College': 'On campus',
  'Atlantic Technical College': 'On campus',
  'Eastern Florida State College': 'On campus',
  'College of Business and Technology': 'On campus',
  'D.G. Erwin Technical Center': 'On campus',
  'First Coast Technical College': 'On campus',
  'Fortis Institute': 'On campus',
  'Southeastern College': 'On campus',
  'Southern Technical College': 'On campus',
  'Aviation Institute of Maintenance': 'On campus',
  'DMAC HVAC School Training': 'On campus',
  'South Florida Academy of AC': 'On campus',
  'HVAC Technical Academy': 'On campus',
  'Emerald Coast Technical College': 'On campus',
  'North Florida College': 'On campus',
  'University of Florida': 'On campus',
  'George Stone Technical College': 'On campus'
};

export function getProgramFormat(programName) {
  return programFormats[programName] || 'Format varies; verify with the school';
}